module.exports = __webpack_public_path__ + "img/insurance.2a06a973.svg";